// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListProjectsMore-modulemore__CWJ2B AIButtonTextGrey-moduleaiButtonTextGrey__mVWNT AIButtonText-moduleaiButtonText__hhww0";
export { _1 as "more" }
